import { gql } from '@apollo/client';

export const getSelectedWorkflowData = gql`
  query fetchSelectedWorkflowData($id: Long!, $workflowType: WorkflowType) {
    workflow(id: $id, workflowType: $workflowType) {
      id
      name
      workflowType
      enabled
      updatedAt
      updatedByUserId
    }
  }
`;
